module.exports = __webpack_public_path__ + "static/media/wallet.93f69ea5.svg";